// AI-generated code - 2026-02-02T13:50:40Z
import { type ApiOrder, EnumProcessState } from '@Model';
import { type Index } from '@synqo/frontend-component-library';
import { useCallback } from 'react';

interface OrderPermissionsOptions {
    allowedPropertiesWhenCompleted?: Index<ApiOrder>[];
}

export function useOrderPermissions(apiOrder: ApiOrder, options: OrderPermissionsOptions = {}) {
    const { allowedPropertiesWhenCompleted = ['remarks'] } = options;

    const forceReadOnly = useCallback(
        (name: string) => {
            if (apiOrder.process_state === EnumProcessState.Completed) {
                return !allowedPropertiesWhenCompleted.includes(name as Index<ApiOrder>);
            }
            return false;
        },
        [apiOrder.process_state, allowedPropertiesWhenCompleted],
    );

    return { forceReadOnly };
}
